import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import _ from 'lodash';

import CreateComment from './CreateComment';

const Comments = ({ proposalId, comments }) => {
  const [allComments, setAllComments] = React.useState([]);

  React.useEffect(() => {
    if (!_.isEmpty(comments)) {
      const allComments = _.filter(
        comments,
        (comment, id) => comment?.proposalId === proposalId
      );
      return setAllComments(allComments);
    }
    return setAllComments([]);
  }, [comments, proposalId]);

  return (
    <div>
      <CreateComment comments={allComments} proposalId={proposalId} />
    </div>
  );
};

Comments.propTypes = {
  proposalId: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  return {
    comments: state.firestore.data.comments,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: 'comments', orderBy: ['createdAt', 'desc'] }])
)(Comments);
